module.exports = __webpack_public_path__ + "media/public/images/logo-small-white-21ca965e4ab28e9af37b7d3aeb0bc879.svg";